import { Component, inject } from '@angular/core';
import { injectDispatch } from '@ngrx/signals/events';
import { Divider } from 'primeng/divider';
import {
  offshoreConsumptionsFormEvents,
  OffshoreConsumptionsFormStore,
  OffshoreReportStore,
} from '@navstation-portal/reporting/data-access/offshore-report';
import { DynamicFormComponent } from '../shared/dynamic-form/dynamic-form.component';
import { FuelSpecsComponent } from './sections/fuel-specs/fuel-specs.component';
import { TotalConsumptionsComponent } from './sections/total-consumptions/total-consumptions.component';
import { AuxEngineConsumptionsComponent } from './sections/aux-engine-consumptions/aux-engine-consumptions.component';
import { BoilerConsumptionsComponent } from './sections/boiler-consumptions/boiler-consumptions.component';
import { InertGasSystemsComponent } from './sections/inert-gas-systems/inert-gas-systems.component';
import { CylinderOilProductionComponent } from './sections/cylinder-oil-production/cylinder-oil-production.component';
import { WaterComponent } from './sections/water/water.component';

@Component({
  selector: 're-offshore-consumptions',
  standalone: true,
  templateUrl: './offshore-consumptions.component.html',
  imports: [
    TotalConsumptionsComponent,
    FuelSpecsComponent,
    DynamicFormComponent,
    AuxEngineConsumptionsComponent,
    BoilerConsumptionsComponent,
    InertGasSystemsComponent,
    CylinderOilProductionComponent,
    WaterComponent,
    FuelSpecsComponent,
    Divider,
  ],
})
export class OffshoreConsumptionsComponent {
  events = injectDispatch(offshoreConsumptionsFormEvents);
  offshoreReportStore = inject(OffshoreReportStore);
  consumptionsStore = inject(OffshoreConsumptionsFormStore);
}
